const V2_UPLOADS_ENABLED_KEY = "v2UploadsEnabled";

/**
 * Check whether the v2 image upload and analysis API should be used in the web app.
 * Defaults to false; set localStorage.setItem("v2UploadsEnabled", "true") to enable.
 */
export const isV2UploadsEnabled = (): boolean => {
  try {
    return localStorage.getItem(V2_UPLOADS_ENABLED_KEY) === "true";
  } catch (error) {
    console.error("Error reading v2 feature flag:", error);
    return false;
  }
};

export const setV2UploadsEnabled = (enabled: boolean): void => {
  try {
    localStorage.setItem(V2_UPLOADS_ENABLED_KEY, String(enabled));
  } catch (error) {
    console.error("Error writing v2 feature flag:", error);
  }
};
